var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table" }, [
    _c("table", [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.districts, function(district) {
          return _c("tr", { key: district.id }, [
            _c(
              "td",
              {
                staticClass: "icon",
                on: {
                  click: function($event) {
                    return _vm.toggleFromList(district)
                  }
                }
              },
              [
                _vm.onList(district.id)
                  ? _c("img", {
                      attrs: { src: "/static/icon_check_circle.svg" }
                    })
                  : _c("img", {
                      attrs: { src: "/static/icon_times_circle.svg" }
                    })
              ]
            ),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(district.display_name))]),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(_vm._f("intToDecimal")(district.rating.rating_min)))
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(_vm._f("intToCurrency")(district.pricing.price_per_hour))
              )
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Bairro")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nota Mínima")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor Hora")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d81ba668", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d81ba668","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coupons/AddDistricts/Districts.vue
// module id = null
// module chunks = 